export default function createPost() {
	return {
		defaultFields: [],
		customFields: [],
		taxonomies: []
	}
}